// src/components/TrackedButton.js
import { Link } from "react-router-dom";

/**
 * TrackedButton component
 * - Use `to="/..."` for internal links (React Router)
 * - Use `href="https://..."` for external links
 * - Always set `eventLabel` for clean GA reporting
 */
export default function TrackedButton({
  children,
  className = "",
  href,
  to,
  eventLabel = "Button Click",
  ...props
}) {
  const handleClick = (e) => {
    if (window.gtag) {
      window.gtag("event", "button_click", {
        event_category: "interaction",
        event_label: eventLabel,
      });
    }
  };

  // Developer warning: don't use both
  if (to && href) {
    console.warn(
      "TrackedButton received both `to` and `href`. Only use one: `to` for internal routes, `href` for external links."
    );
  }

  // Internal routing
  if (to) {
    return (
      <Link to={to} onClick={handleClick} className={className} {...props}>
        {children}
      </Link>
    );
  }

  // External link
  return (
    <a href={href || "#"} onClick={handleClick} className={className} {...props}>
      {children}
    </a>
  );
}

